const Lightbox = (() => {
  const DOM = {};
  let focusedELBeforeOpen,
    focusableEls,
    firstFocusableEl,
    lastFocusableEl,
    hasContent;

  const cacheDOM = () => {
    DOM.body = document.getElementsByTagName("body")[0];
    DOM.lightBoxElement = document.getElementsByClassName("js-lightbox");
    DOM.parentElement = document.getElementsByClassName(
      "js-lightbox-container"
    )[0];
    DOM.lightBoxClose = document.getElementsByClassName("lightbox__close")[0];
    DOM.lightBoxModal = document.getElementsByClassName("lightbox")[0];
  };

  const accessibilityVariables = () => {
    // Variables used for accessibility in keyboardNavigation() function
    const targetEl = document.getElementsByClassName("lightbox")[0];

    focusedELBeforeOpen = document.activeElement;

    focusableEls = targetEl.querySelectorAll(
      'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]'
    );
    focusableEls = Array.prototype.slice.call(focusableEls);

    firstFocusableEl = focusableEls[0];
    lastFocusableEl = focusableEls[focusableEls.length - 1];

    firstFocusableEl.focus();
  };

  const lightboxContent = (el, lightBoxWrapper) => {
    hasContent = el.currentTarget.hasAttribute("data-content");

    if (hasContent) {
      DOM.activeLocationContentEl =
        el.currentTarget.nextElementSibling.children[0];
      lightBoxWrapper.appendChild(DOM.activeLocationContentEl.cloneNode(true));
    }
  };

  const openModal = (el) => {
    el.preventDefault();

    const lightBoxDiv = document.createElement("div");
    lightBoxDiv.classList.add("lightbox");
    lightBoxDiv.classList.add("lightbox--active");
    lightBoxDiv.setAttribute("role", "dialog");

    const lightBoxContainer = document.createElement("div");
    lightBoxContainer.classList.add("lightbox__container");

    const lightBoxWrapper = document.createElement("div");
    lightBoxWrapper.classList.add("lightbox__wrapper");

    const lightBoxButton =
      '<button class="lightbox__close" type="button" aria-label="Close (Press escape to close)" tabindex="0"><span class="accessible-hidden sr-only">Close</span></button>';

    // Check if the Modal needs to display image or content and add it to the lightbox wrapper
    lightboxContent(el, lightBoxWrapper);

    lightBoxWrapper.insertAdjacentHTML("afterbegin", lightBoxButton);
    lightBoxContainer.appendChild(lightBoxWrapper);
    lightBoxDiv.appendChild(lightBoxContainer);

    DOM.parentElement.appendChild(lightBoxDiv);

    const activeLightbox =
      document.getElementsByClassName("lightbox__wrapper")[0].lastElementChild;
    activeLightbox.removeAttribute("aria-label");
    activeLightbox.removeAttribute("tabindex");
    activeLightbox.classList.remove("js-hidden");
    DOM.body.style.overflow = "hidden";
    DOM.body.style.height = "100vh";

    accessibilityVariables();
  };

  const closeModal = () => {
    DOM.lightBoxModal.classList.remove("lightbox--active");

    setTimeout(function () {
      DOM.lightBoxModal.parentNode.removeChild(DOM.lightBoxModal);
    }, 400);

    DOM.body.style.overflow = "";
    DOM.body.style.height = "";

    if (focusedELBeforeOpen) {
      focusedELBeforeOpen.focus();
    }

    if (DOM.activeLocationContentEl) {
      DOM.activeLocationContentEl.setAttribute("aria-label", "hidden");
      DOM.activeLocationContentEl.setAttribute("tabindex", "-1");
    }
  };

  const keyboardNavigation = (event) => {
    const keyTab = 9;
    const keyEsc = 27;

    switch (event.keyCode) {
      case keyTab:
        if (focusableEls.length === 1) {
          event.preventDefault();
          break;
        }
        if (event.shiftKey) {
          if (document.activeElement === firstFocusableEl) {
            e.preventDefault();
            lastFocusableEl.focus();
          }
        } else {
          if (document.activeElement === lastFocusableEl) {
            e.preventDefault();
            firstFocusableEl.focus();
          }
        }
        break;
      case keyEsc:
        closeModal();
        break;
      default:
        break;
    }
  };

  const eventlistener = () => {
    Array.from(DOM.lightBoxElement).forEach((el) => {
      el.addEventListener("click", listenForChange);
      el.addEventListener("click", openModal);
    });

    if (DOM.lightBoxModal) {
      DOM.lightBoxModal.addEventListener("keydown", keyboardNavigation);
    }

    if (DOM.lightBoxClose) {
      DOM.lightBoxClose.addEventListener("click", closeModal);
    }
  };

  const createClassObserver = (target, callback) => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "childList") {
          callback();
        }
      });
    });

    const config = { attributes: false, childList: true, subtree: false };

    observer.observe(target, config);
  };

  const listenForChange = () => {
    createClassObserver(DOM.parentElement, cacheDOM);
    createClassObserver(DOM.parentElement, eventlistener);
  };

  const init = () => {
    cacheDOM();
    eventlistener();
  };

  return {
    init,
  };
})();

export default Lightbox;
